import { IconLink, OwnUpGridWrapper } from '@rategravity/own-up-component-library';
import { ArrowLeftIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/arrow-left';
import React from 'react';
import { BreadcrumbItem, BreadcrumbsContainer, BreadcrumbsList, Link } from './components';

interface BreadCrumbsProps {
  breadCrumbs: Crumb[];
}
interface Crumb {
  title: string;
  path: string;
}
const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ breadCrumbs }) => {
  return (
    <OwnUpGridWrapper>
      <BreadcrumbsContainer>
        <BreadcrumbsList>
          {breadCrumbs?.map((crumb, index) =>
            crumb?.title ? (
              <BreadcrumbItem key={index}>
                {index < breadCrumbs.length - 1 ? (
                  <IconLink
                    link={crumb.path}
                    component={Link}
                    to={crumb.path}
                    iconPlacement={index === 0 ? 'left' : undefined}
                    icon={index === 0 ? <ArrowLeftIcon /> : <></>}
                  >
                    {crumb.title}
                  </IconLink>
                ) : (
                  <span>{crumb.title}</span>
                )}
              </BreadcrumbItem>
            ) : null
          )}
        </BreadcrumbsList>
      </BreadcrumbsContainer>
    </OwnUpGridWrapper>
  );
};

export default BreadCrumbs;
